import { useTranslation } from "react-i18next";
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import Layout from 'Components/Layout';
import DeleteAccount from 'Components/Personal/DeleteAccount/DeleteAccount';
export default (() => {
  const { t } = useTranslation();
  return <Layout>
      <Helmet>
        <title>{t("Delete My Account - HeresMyInfo.com")}</title>
      </Helmet>
      <Container>
        <Row>
          <Col>
            <h1>{t("Delete My Account")}</h1>
            <DeleteAccount />
          </Col>
        </Row>

      </Container>
    </Layout>;
});